import React, {useEffect, useMemo,useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchProducts, fetchProductsSummary} from "../../../../../reduxLib/productLib";
import Pitemlist from "./elements/pitemlist";
import AddProductModal from "./elements/addProductModal";
import EditProductModal from "./elements/editProductModal";
import ViewProductModal from "./elements/viewProductModal";
import PageButtons from "./elements/pageButtons";
import AddProductModal2 from "./elements/addProductModal2";

function ConfirmDeleteModal(props) {
    return null;
}

function ProductsAd() {

    const dispatch = useDispatch();
    const [productSummaryPage,setProductsSummaryPage]=useState([]);
    const productSummaryL= useSelector((state)=> state.productreducer.productSymmaryListpage);
    const state=useSelector((state)=> state.productreducer.state);

    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [openViewModal, setOpenViewModal] = useState(false);



    useEffect(() => {
        if (!productSummaryL || productSummaryL.length === 0 ) {

            dispatch(fetchProducts()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setProductsSummaryPage(action.payload);


                    console.log("playload ",action.payload);
                    console.log("playload E", productSummaryPage);
                }
            });

        }
        else {
            // ίδια κατηγορία -> πάρε cached
            setProductsSummaryPage(productSummaryL);
        }
    }, [dispatch, state,productSummaryL]);
    const refresh = async () => {
        const action = await dispatch(fetchProducts());
        if (action?.payload) setProductsSummaryPage(action.payload);
    };

    // --- handlers
    const handleAddSubmit = async (formData) => {
        // 1) φτιάχνεις payload ή στέλνεις formData όπως το θέλει backend
        // await dispatch(createProduct(formData));
        await refresh();
    };
    const handleViewClick = (product) => {
        setSelectedProduct(product);
        setOpenViewModal(true);
    };


    const handleEditClick = (product) => {
        setSelectedProduct(product);
        setOpenEditModal(true);
    };

    const handleEditSubmit = async (formDataOrPayload) => {
        if (!selectedProduct) return;
        // Αν είναι FormData, το console.log δεν δείχνει περιεχόμενο.
        if (formDataOrPayload instanceof FormData) {
            console.log("edit submit FormData entries:", [...formDataOrPayload.entries()]);
        } else {
            console.log("edit submit payload:", formDataOrPayload);
        }

        if (formDataOrPayload._newUploads?.length) {
            const fd = new FormData();
            fd.append("productID", formDataOrPayload.productID);

            // ίδιο naming που έχεις στο input:
            formDataOrPayload._newUploads.forEach((file) => fd.append("FilesRelated", file));
        }
        // await dispatch(updateProduct({ id: selectedProduct.id, data: formDataOrPayload }));
        await refresh();
    };

    const handleDeleteClick = (product) => {
        setSelectedProduct(product);
        setOpenDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (!selectedProduct) return;
        // await dispatch(deleteProduct(selectedProduct.id));
        setOpenDeleteModal(false);
        setSelectedProduct(null);
        await refresh();
    };

    ///Paging

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // άλλαξέ το ό,τι θες (π.χ. 8/12/20)

    const totalItems = productSummaryPage?.length ?? 0;
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

    const startIndex = (page - 1) * pageSize;
    const endIndexExclusive = Math.min(startIndex + pageSize, totalItems);

    const pagedProducts = (productSummaryPage ?? []).slice(startIndex, endIndexExclusive);
// κράτα το page valid όταν αλλάζει list ή pageSize
    useEffect(() => {
        setPage((p) => Math.min(Math.max(1, p), totalPages));
    }, [totalPages, totalItems, pageSize]);


    return (

        <div id="product-management-content" className="p-8 bg-cream font-script">

            <div id="product-stats" className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Total Products</p>
                            <p className="text-2xl font-bold text-gray-800">{productSummaryPage?.length}</p>
                        </div>
                        <i className="fa-solid fa-shopping-bag text-3xl text-custom-green"></i>
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow p-6 text-center card-hover">
                    <i className="fa-solid fa-plus text-3xl text-custom-green mb-4"></i>

                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                        Add New Product
                    </h3>

                    <p className="text-gray-600 text-sm mb-4">
                        Create a new product listing
                    </p>

                    <button
                        onClick={() => setOpenAddModal(true)}
                        className="bg-custom-green text-white px-6 py-2 rounded-lg font-medium hover:bg-opacity-90"
                    >
                        Add Product
                    </button>
                </div>

                <AddProductModal2
                    open={openAddModal}
                    setOpen={setOpenAddModal}
                    onSubmit={handleAddSubmit}
                />
                <EditProductModal
                    open={openEditModal}
                    setOpen={setOpenEditModal}
                    product={selectedProduct}
                    onSubmit={handleEditSubmit}
                />
                <ConfirmDeleteModal
                    open={openDeleteModal}
                    setOpen={setOpenDeleteModal}
                    title="Delete product"
                    message={`Are you sure you want to delete "${selectedProduct?.name ?? ""}"? This action cannot be undone.`}
                    confirmText="Delete"
                    onConfirm={handleConfirmDelete}
                />
                <ViewProductModal
                    open={openViewModal}
                    setOpen={setOpenViewModal}
                    product={selectedProduct}
                />

            </div>

            <div id="products-table" className="bg-white rounded-lg shadow">
                <div className="p-6 border-b">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-serif font-bold text-custom-green">Products</h2>
                        <div className="flex space-x-2">

                        </div>
                    </div>
                </div>

                <div className="overflow-x-auto">
                <table className="w-full">
                        <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                <input type="checkbox" className="rounded"/>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product ID</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {
                            pagedProducts?.map((product) => (
                                <Pitemlist key={product.id}
                                           image={product.filesRelated?.[0]?.fileLocation}
                                           name={product.name}
                                           description={product.description}
                                           id={product.productID}
                                           category={product.categoryRelId}
                                           price={product.price}
                                           onEdit={() => handleEditClick(product)}
                                           onDelete={() => handleDeleteClick(product)}
                                           onView={() => handleViewClick(product)}
                                />
                            ))
                        }
                        </tbody>
                    </table>
                </div>

                <div className="px-6 py-3 border-t bg-gray-50">
                    <div className="flex items-center justify-between">
                        <div className="text-sm text-gray-700">
                            {totalItems === 0
                                ? "No products"
                                : `Showing ${startIndex + 1} to ${endIndexExclusive} of ${totalItems} products`}
                        </div>

                        <div className="flex items-center gap-2">
                            {/* page size */}
                            <select
                                value={pageSize}
                                onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                                className="px-2 py-2 border rounded-lg text-sm bg-white"
                                title="Rows per page"
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>

                            <button
                                className="px-3 py-2 border rounded-lg text-sm hover:bg-gray-100 disabled:opacity-50"
                                onClick={() => setPage((p) => Math.max(1, p - 1))}
                                disabled={page <= 1}
                            >
                                Previous
                            </button>

                            {/* page numbers */}
                            <PageButtons page={page} totalPages={totalPages} onPage={setPage} />

                            <button
                                className="px-3 py-2 border rounded-lg text-sm hover:bg-gray-100 disabled:opacity-50"
                                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                disabled={page >= totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ProductsAd;